export default __webpack_public_path__ + "static/media/podcast-m.7b6a7448.jpg";